<template>
  <gj-tree-select
      v-bind="$attrs"
      v-on="$listeners"
      :data="treeData"
      select-all-node
      node-key="id"
      :show-checkbox="multiple"
      placeholder="品类"
      :showScroll="true"
  >
  <span class="custom-tree-node" slot-scope="{ data }">
    {{data.label}}
    <span style="padding-left:10px; color: #bfbfbf;">{{data.disabled ? '已停用' : ''}}</span>
  </span>
  </gj-tree-select>
</template>

<script>
  import {mapGetters} from "vuex";

  export default {
    name: "gj-category-select",
    props: {
      active: {
        type: Boolean,
        default: false
      },
      multiple: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        treeData:[]
      }
    },
    methods:{
        handelTreeData(tree) {
          for (let item of tree) {
            item.disabled = Boolean(item.state==="Inactive")
            if (Array.isArray(item.children)) {
              this.handelTreeData(item.children)
            }
          }
        }
    },
    created() {
      let data = this._.cloneDeep(this.allProductCategoryTree)
     this.handelTreeData(data)
     this.treeData = data
    },
    computed: {
      ...mapGetters(['allProductCategoryTree']),
    }
  }
</script>

<style lang="scss" scoped>
  /deep/ .el-tree{
    margin-right: 4px;
  }
</style>


allProductCategoryTree
